import ccUtils from '../fsUtils/CountdownClockUtils';

class CountdownClock {
    constructor(clock) {
        // Caching variables
        this.browser = window.navigator.userAgent.toLowerCase();
        this.clock = clock;
        // Get the message instance
        this.jsMsgHook = clock.querySelector('.sidebar-message');
        // Get the Endtime
        var endtime = this.endtime = clock.querySelector('.sidebar-timer__wrap').getAttribute('data-endtime');
        this.timeinterval = undefined;

        // Run the function once before interval to avoid a delayed start
        this.updateClock(clock, endtime);

        // Set up the time interval to tick the clock down
        this.executeInterval(clock, endtime);

    } // constructor()

    // Pulling this out of the loop
    executeInterval(clock, endtime) {

        clock = clock || this.clock;
        endtime = endtime || this.endtime;

        this.timeinterval = setInterval(function () {

            // Update the clock every second
            this.updateClock(clock, endtime);

        }.bind(this), 1000);

    } // executeInterval()
    
    // Update the DOM with the new time
    updateClock(clock, endtime) {
        var clockWrap = clock.querySelector('.sidebar-timer__wrap');
        var expirationAction = clockWrap.getAttribute('data-expiration');
        var countBy = clockWrap.getAttribute('data-showby');
        var timer = clock.querySelector('.sidebar-timer');

        var t = ccUtils.getTimeRemaining(endtime, countBy);
        var days = clock.querySelector('.timer-days .sidebar-timer__value');
        var hours = clock.querySelector('.timer-hours .sidebar-timer__value');
        var minutes = clock.querySelector('.timer-minutes .sidebar-timer__value');
        var seconds = clock.querySelector('.timer-seconds .sidebar-timer__value');

        days.innerHTML = t.days;
        if (t.hours <= 99) {
            hours.innerHTML = t.hours;
        } else {
            hours.innerHTML = t.hours;
            timer.classList.add('is-hourly-wide');
        }
        minutes.innerHTML = t.minutes;
        seconds.innerHTML = t.seconds;

        if (countBy.indexOf('hour') > -1 || t.days <= 0) {
            timer.classList.add('is-hourly');
        }

        clock.classList.remove('is-removed');
        
        if (t.total === NaN || t.total <= 0) {

            let clockWrapClassList = clockWrap.classList;
            // If we should be displaying the message upon expiration, do so now
            if (expirationAction === 'display-message') {
                clockWrapClassList.add('is-removed');

                let messageTagClassList = clock.querySelector('.sidebar-message').classList;
                messageTagClassList.remove('is-removed');
                messageTagClassList.remove('is-active');

                
                clockWrapClassList.remove('is-active');

            } else {
                let parentEl = clock.parentNode;

                if (parentEl && parentEl.contains(clock)) {
                    if (parentEl.classList.contains('top-right-rail') || parentEl.classList.contains('right-half-headlines')) {
                        let lowerRailEl = document.querySelector('.right-rail.lower-right-rail');
                        if(lowerRailEl.children.length > 1) {
                            parentEl.replaceChild(lowerRailEl.children[1], this.clock);
                        } else parentEl.removeChild(clock);
                    } else parentEl.removeChild(clock);
                }
            } // if (expirationAction === 'display-message')

            // Stop the timer
            clearInterval(this.timeinterval);
        } // if ( t.total === NaN || t.total <= 0 )

    } // updateClock()

} // Sidebar {}

export default CountdownClock;